import React from "react";

type SpaceProps = {
  x?: number;
  y?: number;
};

function Space({ x, y }: SpaceProps) {
  return <div style={{ marginLeft: x || 0, marginTop: y || 0 }} />;
}
export default Space;
